export function getTopbar() {
  return document.querySelector('mymunters-topbar');
}

export function notify({ title, description, type, persistent, link }) {
  const topbar = getTopbar();
  topbar?.notify({ title, description, type, persistent, link });
}

export function waitForElement(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}
